// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.user.LeasingUserWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeasingUserWebApiHandler_associateUser,
  LeasingUserWebApiHandler_getLeasingUserPage,
  LeasingUserWebApiHandler_getLeasingUserPage_Path,
  LeasingUserWebApiHandler_verifyUserInfo,
  LeasingUserWebApiHandler_verifyUserInfo_Path,
  LeasingUserWebApiHandler_verifyUserInfoForOuid,
  LeasingUserWebApiHandler_verifyUserInfoForOuid_Path,
} from '@zg-rentals/ts-leasing-client';

import type {
  AssociateUserWebApiResponseDto,
  GetLeasingUserPageWebApiResponseDto,
  VerifyUserInfoWebApiResponseDto,
} from '@zg-rentals/ts-leasing-client';

interface AssociateUserParams {
  ouid: string;
}
interface GetLeasingUserPageParams {
  leaseId: number;
}
interface VerifyUserInfoParams {
  verifyUserInfoToken: string;
}
interface VerifyUserInfoForOuidParams {
  ouid: string;
  verifyUserInfoToken: string;
}

export interface LeasingUserWebApiHandler_associateUser_Args {
  getParams: AssociateUserParams;
}

export type LeasingUserWebApiHandler_associateUser_Options = UseMutationOptions<
  AssociateUserWebApiResponseDto,
  unknown,
  LeasingUserWebApiHandler_associateUser_Args
>;

/**
 * associate user with encoded lease, role and index
 */
export const useLeasingUserWebApiHandler_associateUser = ({
  httpClient,
  ...options
}: Omit<LeasingUserWebApiHandler_associateUser_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeasingUserWebApiHandler_associateUser_Args) =>
      LeasingUserWebApiHandler_associateUser(args.getParams, httpClient),
  });
};

export type LeasingUserWebApiHandler_getLeasingUserPage_Options = UseQueryOptions<
  GetLeasingUserPageWebApiResponseDto,
  unknown,
  GetLeasingUserPageWebApiResponseDto,
  readonly [string, GetLeasingUserPageParams]
>;

const LeasingUserWebApiHandler_getLeasingUserPage_GetKey = (getParams: GetLeasingUserPageParams) =>
  [LeasingUserWebApiHandler_getLeasingUserPage_Path, getParams] as const;

export const LeasingUserWebApiHandler_getLeasingUserPage_queryOptions = (
  getParams: GetLeasingUserPageParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: LeasingUserWebApiHandler_getLeasingUserPage_GetKey(getParams),
    queryFn: () => LeasingUserWebApiHandler_getLeasingUserPage(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get leasing user page
 */
export const useLeasingUserWebApiHandler_getLeasingUserPage = (
  getParams: GetLeasingUserPageParams,
  {
    httpClient,
    ...options
  }: Omit<LeasingUserWebApiHandler_getLeasingUserPage_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...LeasingUserWebApiHandler_getLeasingUserPage_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useLeasingUserWebApiHandler_getLeasingUserPage.getKey = LeasingUserWebApiHandler_getLeasingUserPage_GetKey;

export type LeasingUserWebApiHandler_verifyUserInfo_Options = UseQueryOptions<
  VerifyUserInfoWebApiResponseDto,
  unknown,
  VerifyUserInfoWebApiResponseDto,
  readonly [string, VerifyUserInfoParams]
>;

const LeasingUserWebApiHandler_verifyUserInfo_GetKey = (getParams: VerifyUserInfoParams) =>
  [LeasingUserWebApiHandler_verifyUserInfo_Path, getParams] as const;

export const LeasingUserWebApiHandler_verifyUserInfo_queryOptions = (
  getParams: VerifyUserInfoParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: LeasingUserWebApiHandler_verifyUserInfo_GetKey(getParams),
    queryFn: () => LeasingUserWebApiHandler_verifyUserInfo(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * make sure user token still belongs to same tenant
 */
export const useLeasingUserWebApiHandler_verifyUserInfo = (
  getParams: VerifyUserInfoParams,
  {
    httpClient,
    ...options
  }: Omit<LeasingUserWebApiHandler_verifyUserInfo_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...LeasingUserWebApiHandler_verifyUserInfo_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useLeasingUserWebApiHandler_verifyUserInfo.getKey = LeasingUserWebApiHandler_verifyUserInfo_GetKey;

export type LeasingUserWebApiHandler_verifyUserInfoForOuid_Options = UseQueryOptions<
  VerifyUserInfoWebApiResponseDto,
  unknown,
  VerifyUserInfoWebApiResponseDto,
  readonly [string, VerifyUserInfoForOuidParams]
>;

const LeasingUserWebApiHandler_verifyUserInfoForOuid_GetKey = (getParams: VerifyUserInfoForOuidParams) =>
  [LeasingUserWebApiHandler_verifyUserInfoForOuid_Path, getParams] as const;

export const LeasingUserWebApiHandler_verifyUserInfoForOuid_queryOptions = (
  getParams: VerifyUserInfoForOuidParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: LeasingUserWebApiHandler_verifyUserInfoForOuid_GetKey(getParams),
    queryFn: () => LeasingUserWebApiHandler_verifyUserInfoForOuid(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * make sure co-landlord's session is still valid
 */
export const useLeasingUserWebApiHandler_verifyUserInfoForOuid = (
  getParams: VerifyUserInfoForOuidParams,
  {
    httpClient,
    ...options
  }: Omit<LeasingUserWebApiHandler_verifyUserInfoForOuid_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...LeasingUserWebApiHandler_verifyUserInfoForOuid_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useLeasingUserWebApiHandler_verifyUserInfoForOuid.getKey = LeasingUserWebApiHandler_verifyUserInfoForOuid_GetKey;
